// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-container {
  padding: 1rem;
}

.day-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 1rem;
}

.day-tab {
  padding: 8px 16px;
  border: none;
  background-color: #e0e0e0;
  cursor: pointer;
  border-radius: 4px;
  font-weight: bold;
}

.day-tab.active {
  background-color: #007bff;
  color: rgb(58, 17, 243);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 2rem;
}

.data-table th, .data-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.data-table th {
  background-color: #f5f5f5;
  color: blue;
}

.upcoming-events {
  margin-top: 2rem;
}

.event-grid {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.event-card {
  border: 1px solid #ccc;
  padding: 12px;
  border-radius: 8px;
  background-color: #fafafa;
  width: 200px;
}

.event-title {
  font-weight: bold;
  margin-bottom: 6px;
}

.candidate-meetings {
  margin-top: 2rem;
}

.candidate-meetings h3 {
  margin-bottom: 1rem;
}

.personal-reminders {
  margin-top: 2rem;
}

.personal-reminders h3 {
  margin-bottom: 0.75rem;
}

.personal-reminders ul {
  list-style: disc;
  padding-left: 1.5rem;
}

.personal-reminders li {
  margin-bottom: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tabs/Schedule.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".schedule-container {\n  padding: 1rem;\n}\n\n.day-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 1rem;\n}\n\n.day-tab {\n  padding: 8px 16px;\n  border: none;\n  background-color: #e0e0e0;\n  cursor: pointer;\n  border-radius: 4px;\n  font-weight: bold;\n}\n\n.day-tab.active {\n  background-color: #007bff;\n  color: rgb(58, 17, 243);\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 2rem;\n}\n\n.data-table th, .data-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n}\n\n.data-table th {\n  background-color: #f5f5f5;\n  color: blue;\n}\n\n.upcoming-events {\n  margin-top: 2rem;\n}\n\n.event-grid {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.event-card {\n  border: 1px solid #ccc;\n  padding: 12px;\n  border-radius: 8px;\n  background-color: #fafafa;\n  width: 200px;\n}\n\n.event-title {\n  font-weight: bold;\n  margin-bottom: 6px;\n}\n\n.candidate-meetings {\n  margin-top: 2rem;\n}\n\n.candidate-meetings h3 {\n  margin-bottom: 1rem;\n}\n\n.personal-reminders {\n  margin-top: 2rem;\n}\n\n.personal-reminders h3 {\n  margin-bottom: 0.75rem;\n}\n\n.personal-reminders ul {\n  list-style: disc;\n  padding-left: 1.5rem;\n}\n\n.personal-reminders li {\n  margin-bottom: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
